import React from 'react';
import { BRAND } from '../data/site';
export function SiteFooter() {
  return <footer className="w-full bg-sage-800 px-5 py-14 text-center sm:px-8" data-id="element-197" data-mp="3r8j5b1nlzaor">
      <p className="font-serif text-2xl text-cream" data-id="element-198" data-mp="3racbygy81uwr">{BRAND.name}</p>
      <p className="mt-3 text-[12px] uppercase tracking-[0.18em] text-sage-200" data-id="element-199" data-mp="3mg83ft9b5etk">
        Botanical crafts · Digital guides
      </p>
      <p className="mt-6 text-[11.5px] text-sage-300" data-id="element-200" data-mp="3hglsjqgycanx">
        © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
      </p>
    </footer>;
}